// CSS
import '@/assets/css/notification.scss';

// Lib 
import { mapState } from "vuex";

// Event, Dialog
import EventBus from "@/event/EventBus";

// Api
import api from '@/api/baseApi';

// Constant 
import { SETTINGS_COUPONS_API } from "@/constant/apiSettings";
import { API_CALL_STATUS } from "@/constant/baseConstant";

// Extend
import base from '@/scripts/base';

// Function 
const queryString = require('query-string');

export default {

  components: {
  },

  extends: base,

  data() {
    return {
      pagination: {
        status: 1,
        orderBy: 'A.CREATED_AT',
        directionSort: 'DESC',
        pageIndex: 1,
        pageSize: 20,
        outRowsNumber: 0,
      },
      listData: [],
    }
  },

  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
  },

  created() {
  },

  methods: {

    //#region Processing event
    processingEvent(param) {
      this[param.event](param.data);
    },
    //#endregion   

    //#region Get data
    getData() {
      this.feedStatusLoading(API_CALL_STATUS.LOADING);
      api.baseRequest(SETTINGS_COUPONS_API.NOTIFICATIONS_VIEW, null, `?${queryString.stringify(this.pagination)}`)
        .then((res) => {
          let responseData = res.data;
          let pagingItem = responseData.pagingItem;
          this.listData = responseData.data;
          this.pagination.orderBy = pagingItem.orderBy;
          this.pagination.directionSort = pagingItem.directionSort;
          this.pagination.pageIndex = pagingItem.pageIndex;
          this.pagination.pageSize = pagingItem.pageSize;
          this.pagination.outRowsNumber = pagingItem.outRowsNumber;
          this.feedStatusLoading(API_CALL_STATUS.SUCCESS, this.listData);

          this.removeStatus();
        })
        .catch(error => {
          // this.processCatchApiRequest(error, "Request failed ...")
        });
    },
    //#endregion 
  },
}